import { useMemo } from 'react';

import {
  MenuItem,
  NutritionMenuItem,
} from '../../../../core/api/menu/menu.types';
import { NutritionInfoDataDictionary } from '../../../../core/state/menu/menu.types';

type UseMenuItemNutritionInfo = {
  menuItemNutritionInfo: NutritionMenuItem;
  menuItemOptionSetItemNutritionInfos: NutritionMenuItem[];
};

export const useMenuItemNutritionInfo = (
  nutritionInfoData: NutritionInfoDataDictionary,
  selectedMenuItem: MenuItem,
): UseMenuItemNutritionInfo => {
  const menuItemNutritionInfo = useMemo((): NutritionMenuItem => {
    if (nutritionInfoData?.menuItems && selectedMenuItem) {
      return nutritionInfoData.menuItems[selectedMenuItem.PublicId] || null;
    }
    return null;
  }, [nutritionInfoData, selectedMenuItem]);

  // commented out for now we don't want to display option nutrition info

  // const menuItemOptionSetItemNutritionInfos =
  //   useMemo((): NutritionMenuItemOptionSetItems[] => {
  //     const menuItemOptionSetItemNutritionInfoArray: NutritionMenuItemOptionSetItems[] =
  //       [];

  //     if (nutritionInfoData?.menuItemOptionSetItems && selectedMenuItem) {
  //       selectedMenuItem.MenuItemOptionSets.forEach((menuItemOptionSet) =>
  //         menuItemOptionSet.MenuItemOptionSetItems.forEach(
  //           (menuItemOptionSetItem) => {
  //             const nutritionInfo =
  //               nutritionInfoData.menuItemOptionSetItems[
  //                 menuItemOptionSetItem.PublicId
  //               ];

  //             if (nutritionInfo) {
  //               menuItemOptionSetItemNutritionInfoArray.push(nutritionInfo);
  //             }
  //           },
  //         ),
  //       );
  //     }

  //     return menuItemOptionSetItemNutritionInfoArray;
  //   }, [nutritionInfoData, selectedMenuItem]);

  return {
    menuItemNutritionInfo,
    menuItemOptionSetItemNutritionInfos: [],
  };
};
